export default __webpack_public_path__ + "static/media/icon-Catalogs-Brochures.59032509.svg";